import axios from 'axios';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import { hideActivePopup } from 'Store/Overlay/Overlay.action';
import { showPopup } from 'Store/Popup/Popup.action';
import { ItemOptionsType, ProductType } from 'Type/ProductList.type';
import getStore from 'Util/Store';

import jsonTallasData from './json_tallas.json';
import YBRecomendadorTalla from './YBRecomendadorTalla.component';

/** @namespace Elganso/Component/YBRecomendadorTalla/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    hideActivePopup: () => dispatch(hideActivePopup())
});

/** @namespace Elganso/Component/YBRecomendadorTalla/Container/mapStateToProps */
export const mapStateToProps = () => ({});

/** @namespace Elganso/Component/YBRecomendadorTalla/Container */
export class YBRecomendadorTallaContainer extends PureComponent {
    static propTypes = {
        product: ProductType.isRequired,
        bundleImg: PropTypes.string,
        bundleSku: PropTypes.string,
        bundleName: PropTypes.string,
        bundleOptions: PropTypes.arrayOf(ItemOptionsType),
        isShowPopup: PropTypes.bool
    };

    static defaultProps = {
        bundleImg: '',
        bundleSku: '',
        bundleName: '',
        bundleOptions: [],
        isShowPopup: true
    };

    state = {
        id_pop_up_recomendador: this.getPopupId(),
        activePopupTab: 'FORM',
        foundSavedData: false,
        recomendedSize: '',
        percentages: [],
        currentGenderSelected: 'M',
        currentYearSelected: '2000',
        currentHeightSelected: 160,
        currentWeightSelected: 80,
        currentFittingSelected: 'N',
        genderOptions: this.genderOptions(),
        yearOptions: this.yearOptions(),
        fittingOptions: this.fittingOptions(),
        bundle_sku: '',
        openedPopup: false,
        showRecomendador: true
    };

    containerFunctions = {
        addToCart: this.addToCart.bind(this),
        returnToForm: this.returnToForm.bind(this),
        returnToGuide: this.returnToGuide.bind(this),
        showRecomendadorForm: this.showRecomendadorForm.bind(this),
        showGuiaDeTallas: this.showGuiaDeTallas.bind(this),
        onPopupTabClicked: this.onPopupTabClicked.bind(this),
        onGenderSelected: this.onGenderSelected.bind(this),
        onYearSelected: this.onYearSelected.bind(this),
        onHeightChange: this.onHeightChange.bind(this),
        onWeightChange: this.onWeightChange.bind(this),
        onFittingSelected: this.onFittingSelected.bind(this),
        submitForm: this.submitForm.bind(this),
        closePopup: this.closePopup.bind(this)
    };

    componentDidMount() {
        const { openedPopup, showRecomendador } = this.state;

        this.checkShowRecomendador();

        if (openedPopup && showRecomendador) {
            this.getSavedValues();
        }
    }

    containerProps() {
        const {
            product, bundleImg, bundleSku, bundleName, bundleOptions, isShowPopup
        } = this.props;
        const {
            id_pop_up_recomendador,
            activePopupTab,
            foundSavedData,
            recomendedSize,
            percentages,
            currentGenderSelected,
            currentYearSelected,
            currentHeightSelected,
            currentWeightSelected,
            currentFittingSelected,
            genderOptions,
            yearOptions,
            fittingOptions,
            bundle_sku,
            showRecomendador
        } = this.state;

        return {
            product,
            bundleImg,
            bundleSku,
            bundleName,
            bundleOptions,
            isShowPopup,
            id_pop_up_recomendador,
            activePopupTab,
            foundSavedData,
            recomendedSize,
            percentages,
            currentGenderSelected,
            currentYearSelected,
            currentHeightSelected,
            currentWeightSelected,
            currentFittingSelected,
            genderOptions,
            yearOptions,
            fittingOptions,
            bundle_sku,
            showRecomendador
        };
    }

    checkShowRecomendador() {
        const { product: { type_id = '', gruporemarketing = '' } } = this.props;
        let isAccepted = false;
        let show = true;

        const {
            ConfigReducer: {
                recomendadorTallasActivo = false,
                gruposRemarketing = []
            }
        } = getStore().getState();

        if (!recomendadorTallasActivo) {
            show = false;
        } else if (type_id === 'simple') {
            show = false;
        } else if (gruporemarketing === null || gruporemarketing === '') {
            show = false;
        } else {
            isAccepted = gruposRemarketing.find((i) => i === gruporemarketing);

            if (!isAccepted) {
                show = false;
            }
        }

        if (!show) {
            this.setState({ showRecomendador: false });
        }
    }

    getPopupId() {
        const { product, product: { id = '' }, bundleSku } = this.props;

        if (product.type_id === 'bundle') {
            // Si es bundle, creamos el identificador con el sku del hijo
            return `id_pop_up_recomendador_${bundleSku}`;
        }

        // Si no es bundle, creamos el identificador con el id de producto
        return `id_pop_up_recomendador_${id}`;
    }

    getSavedValues() {
        const { product: { type_id = '' } } = this.props;
        let data = localStorage.getItem('recomendadorTallaDatos');

        if (data !== null) {
            data = JSON.parse(data);

            this.setState({
                foundSavedData: type_id !== 'bundle',
                currentGenderSelected: data.gender,
                currentYearSelected: data.year,
                currentHeightSelected: data.height,
                currentWeightSelected: data.weight,
                currentFittingSelected: data.fitting
            });

            this.calculateRecomendedSize([data.gender, data.year, data.height, data.weight, data.fitting]);
        }
    }

    getFormedUserData(userData) {
        const genderData = userData[0];
        const yearData = userData[1];
        const heightData = userData[2];
        const weightData = userData[3];
        const fittingData = userData[4];
        const userType = `${genderData}-${yearData}-${heightData}-${weightData}-${fittingData}`;

        return userType;
    }

    calculateRecomendedSize(userData) {
        const { product: { gruporemarketing = '' } } = this.props;
        let data = localStorage.getItem('recomendadorTallaRecomendados');
        let lastRecomendedSize = '';
        let lastRecomendedPercentajes = [];
        let size = '';
        const userType = this.getFormedUserData(userData);

        if (gruporemarketing !== null && gruporemarketing !== '') {
            if (data !== null) {
                data = JSON.parse(data);

                // eslint-disable-next-line no-prototype-builtins
                if (data.hasOwnProperty(userType)) {
                    // eslint-disable-next-line no-prototype-builtins
                    if (data[userType].hasOwnProperty(gruporemarketing)) {
                        // eslint-disable-next-line no-prototype-builtins
                        if (data[userType][gruporemarketing].hasOwnProperty('size')) {
                            lastRecomendedSize = data[userType][gruporemarketing].size;
                        }
                        // eslint-disable-next-line no-prototype-builtins
                        if (data[userType][gruporemarketing].hasOwnProperty('size')) {
                            lastRecomendedPercentajes = data[userType][gruporemarketing].percentages;
                        }
                    }
                }
            }
        }

        if (lastRecomendedSize !== '') {
            // Si ya hemos recomendado esa talla antes para ese grupo no llamamos a la api
            this.setState({ recomendedSize: lastRecomendedSize });
            this.setState({ percentages: lastRecomendedPercentajes });
            this.markRecomendedSize(lastRecomendedSize);
        } else {
            // REALIZAR CALCULOS DE TALLA RECOMENDADA
            const frase = this.constructorFraseConsulta();

            if (frase) {
                const url = '/rest/es/V1/recomendarTalla/askChatGPT';

                axios.post(url, {
                    question: frase
                }).then(
                    /** @namespace Elganso/Component/YBRecomendadorTalla/Container/YBRecomendadorTallaContainer/calculateRecomendedSize/then/catch/post/then */
                    (response) => {
                        if (response.status === 200) {
                            const res = JSON.parse(response.data, true);
                            const tallas = JSON.parse(res.msg);
                            let val = 0;
                            const percentages = [];

                            Object.entries(tallas.recomendacion_talla).forEach(([key, value]) => {
                                let formatVal = '';
                                // Comprobamos que el porcentaje sea numerico y si fuera un string con el simbolo % lo procesamos
                                if (typeof value === 'string') {
                                    formatVal = value.replace('%', '');
                                } else {
                                    formatVal = value;
                                }

                                if (formatVal > val) {
                                    size = key;
                                    val = formatVal;
                                }

                                if (formatVal > 0) {
                                    percentages.push({
                                        [key]: formatVal
                                    });
                                }
                            });

                            this.setState({ recomendedSize: size, percentages });
                            this.markRecomendedSize(size);

                            if (gruporemarketing !== '') {
                                if (data !== null) {
                                    localStorage.setItem(
                                        'recomendadorTallaRecomendados',
                                        JSON.stringify({
                                            ...data,
                                            [userType]: {
                                                ...data[userType],
                                                [gruporemarketing]: {
                                                    size,
                                                    percentages
                                                }
                                            }
                                        })
                                    );
                                } else {
                                    localStorage.setItem(
                                        'recomendadorTallaRecomendados',
                                        JSON.stringify({
                                            [userType]: {
                                                [gruporemarketing]: {
                                                    size,
                                                    percentages
                                                }
                                            }
                                        })
                                    );
                                }
                            }
                        } else {
                            this.setState({ foundSavedData: false });
                        }
                    }
                ).catch(
                    /** @namespace Elganso/Component/YBRecomendadorTalla/Container/YBRecomendadorTallaContainer/calculateRecomendedSize/then/catch */
                    (error) => {
                        if (error) {
                            this.setState({ foundSavedData: false });
                        }
                    }
                );
            }
        }
    }

    markRecomendedSize(size) {
        const {
            product,
            product: { sku = '' },
            bundleSku,
            isShowPopup
        } = this.props;

        if (isShowPopup) {
            if (product.type_id === 'bundle') {
                const tallaSeleccionada = document.querySelector(`[data-product-sku="${bundleSku}"] [data-product-option="${size}"]`);

                if (tallaSeleccionada) {
                    if (!tallaSeleccionada.classList.contains('Field-RadioLabel_isDisabled')) {
                        tallaSeleccionada.click();
                    }
                }
            } else {
                const product_sku = `${sku}-${size}`;
                const tallaSeleccionada = document.querySelector(`[data-product-sku="${product_sku}"]`);

                if (tallaSeleccionada) {
                    if (!tallaSeleccionada.classList.contains('ProductAttributeValue-String_isSelected') && !tallaSeleccionada.classList.contains('ProductAttributeValue-String_isNotAvailable')) {
                        tallaSeleccionada.click();
                    }
                }
            }
        }
    }

    addToCart() {
        const { product: { sku = '' }, isShowPopup } = this.props;
        const { recomendedSize } = this.state;

        const product_sku = `${sku}-${recomendedSize}`;
        const tallaSeleccionada = document.querySelector(`[data-product-sku="${product_sku}"]`);
        const buttonAddToCart = document.querySelector(`[data_add_sku="${product_sku}"]`);

        if (tallaSeleccionada) {
            if (tallaSeleccionada.classList.contains('ProductAttributeValue-String_isSelected')) {
                if (isShowPopup) {
                    if (buttonAddToCart) {
                        buttonAddToCart.click();
                    }
                } else {
                    tallaSeleccionada.click();
                }
            } else if (!tallaSeleccionada.classList.contains('ProductAttributeValue-String_isSelected') && !tallaSeleccionada.classList.contains('ProductAttributeValue-String_isNotAvailable')) {
                if (isShowPopup) {
                    tallaSeleccionada.click();

                    if (buttonAddToCart) {
                        buttonAddToCart.click();
                    }
                } else {
                    tallaSeleccionada.click();
                }
            }
        }

        if (isShowPopup) {
            this.closePopup();
        }
    }

    returnToForm() {
        this.setState({ recomendedSize: '', foundSavedData: false });
    }

    returnToGuide() {
        this.setState({ activePopupTab: 'GUIA' });
    }

    onPopupTabClicked(tab) {
        this.setState({ activePopupTab: tab });
    }

    showRecomendadorForm() {
        const store = getStore();
        const { dispatch } = store;
        const { id_pop_up_recomendador } = this.state;

        this.setState({ openedPopup: true });

        this.getSavedValues();

        dispatch(showPopup(id_pop_up_recomendador));
    }

    showGuiaDeTallas() {
        const store = getStore();
        const { dispatch } = store;
        dispatch(showPopup('guia_de_tallas', { title: __('Size Guide') }));
    }

    onGenderSelected(_, field) {
        const { value: gender = '' } = field || {};

        this.setState({ currentGenderSelected: gender });
    }

    onYearSelected(_, field) {
        const { value: year = '' } = field || {};

        this.setState({ currentYearSelected: year });
    }

    onHeightChange(e) {
        const qty = e.target.value;

        if (qty !== undefined && qty !== null && qty !== '') {
            this.setState({ currentHeightSelected: qty });
        }
    }

    onWeightChange(e) {
        const qty = e.target.value;

        if (qty !== undefined && qty !== null && qty !== '') {
            this.setState({ currentWeightSelected: qty });
        }
    }

    onFittingSelected(_, field) {
        const { value: fitting = '' } = field || {};

        this.setState({ currentFittingSelected: fitting });
    }

    genderOptions() {
        return [
            {
                key: 'M', id: 'M', value: 'M', label: __('Male'), tag: 'Masculino'
            },
            {
                key: 'F', id: 'F', value: 'F', label: __('Female'), tag: 'Femenino'
            }
        ];
    }

    yearOptions() {
        const opciones = [];
        const fechaActual = new Date();
        const anoActual = fechaActual.getFullYear();

        for (let i = anoActual; i >= (anoActual - 100); i--) {
            const opcion = {
                key: i.toString(),
                id: i.toString(),
                value: i.toString(),
                label: i.toString()
            };

            opciones.push(opcion);
        }

        return opciones;
    }

    fittingOptions() {
        return [
            {
                key: 'H', id: 'H', value: 'H', label: __('Loose'), tag: 'ancha'
            },
            {
                key: 'N', id: 'N', value: 'N', label: __('Normal'), tag: 'normal'
            },
            {
                key: 'A', id: 'A', value: 'A', label: __('Tight'), tag: 'ajustada'
            }
        ];
    }

    submitForm() {
        const {
            currentGenderSelected, currentYearSelected, currentHeightSelected, currentWeightSelected, currentFittingSelected
        } = this.state;

        localStorage.setItem(
            'recomendadorTallaDatos',
            JSON.stringify({
                gender: currentGenderSelected,
                year: currentYearSelected,
                height: currentHeightSelected,
                weight: currentWeightSelected,
                fitting: currentFittingSelected
            })
        );

        this.setState({ foundSavedData: true });
        this.calculateRecomendedSize([currentGenderSelected, currentYearSelected, currentHeightSelected, currentWeightSelected, currentFittingSelected]);
    }

    constructorFraseConsulta() {
        const {
            bundleName,
            bundleOptions,
            product: {
                type_id = '', name = '', configurable_options = {}, gruporemarketing = ''
            }
        } = this.props;
        const {
            currentGenderSelected, currentYearSelected, currentHeightSelected, currentWeightSelected, currentFittingSelected, genderOptions, fittingOptions
        } = this.state;

        let textName = '';
        let textTallas = '';

        let textGender = '';
        genderOptions.some((option) => {
            if (option.key === currentGenderSelected) {
                textGender = option.tag;
            }

            return null;
        });

        let textFitting = '';
        fittingOptions.some((option) => {
            if (option.key === currentFittingSelected) {
                textFitting = option.tag;
            }

            return null;
        });

        if (type_id !== 'bundle') {
            textName = name;

            const arrayTallas = Object.values(configurable_options.size.attribute_options).map((option) => option.label);
            textTallas = arrayTallas.join(',');
        } else {
            textName = bundleName;
            bundleOptions.shift(); // Quitamos la primera posicion ya que es la talla nulla/none

            const arrayTallas = bundleOptions.map((option) => option.attribute_options[0].size);
            textTallas = arrayTallas.join(',');
        }

        let frase = `Eres un desarrollador senior y tu trabajo es seguir cuidadosamente las instrucciones dadas para generar el código JSON requerido.

        Debes generar porcentajes de las 2 tallas más recomendadas para esta persona.
        Elige las medidas de los productos que correspondan con el nombre del producto.
        Los 2 porcentajes deben sumar obligatoriamente 100% pero nunca pueden ser porcentajes iguales, es decir una de las tallas debe tener un porcentaje mayor respecto a la otra.
        El resto de tallas debes ponerle porcentaje a 0 o no incluirlas en el JSON.

            ** Datos del producto:
                - Nombre: '${textName}'
                - Marca: 'ElGanso'
                - Tallas disponibles: ${textTallas}

        `;

        const actualDate = new Date();
        const customerAge = actualDate.getFullYear() - currentYearSelected;
        let infoTallas = '';

        if (gruporemarketing === 'Complementos') {
            infoTallas = jsonTallasData[gruporemarketing];
        } else if (customerAge <= 15) {
            infoTallas = jsonTallasData.kids;
        } else if (textGender === 'Masculino') {
            infoTallas = jsonTallasData.hombre;
        } else if (textGender === 'Femenino') {
            infoTallas = jsonTallasData.mujer;
        }

        const datosTallas = infoTallas[gruporemarketing];

        if (datosTallas !== undefined && datosTallas !== null) {
            frase += '    ** Medidas productos';

            Object.entries(datosTallas).forEach(([tipo, medidas]) => {
                frase += `
                - ${tipo}:`;

                Object.entries(medidas).forEach(([medida, tallas]) => {
                    frase += `
                    · ${medida}: `;

                    Object.entries(tallas).forEach(([talla, valor]) => {
                        frase += `${valor} (talla ${talla}), `;
                    });
                });
            });
        }

        frase += `
        
            ** Datos de la persona:
                - Género: '${textGender}'
                - Año nacimiento: '${currentYearSelected}'
                - Altura: '${currentHeightSelected} cm'
                - Peso: '${currentWeightSelected} kilos'
                - Le gusta que la ropa le quede '${textFitting}'.
        
            ** asegúrese de aplicar esas restricciones y sígalas directamente y no se salte ninguna de ellas:
                - Devuélve el resultado en formato JSON
                - Sin comentarios para poder procesarlo
                - Sin incluir los datos que ya te he pasado
                - Ordenado por mayor porcentaje
                - La clave del objeto sea recomendacion_talla.
                - El formato de la respuesta unicamente tiene que ser: 
                    {
                        "recomendacion_talla": {
                            "talla": porcentaje
                        }
                    }
                - Salida sin introducción, sin explicación, solo código JSON
                - NO COMETAS NINGÚN ERROR, comprueba si cometiste alguno
                - Solo devuelve código JSON y nada más.
                - No incluyas DOCUMENACIÓN EN LA SALIDA.
        `;

        return frase;
    }

    closePopup() {
        const { hideActivePopup } = this.props;

        hideActivePopup();
        this.setState({ openedPopup: false });
    }

    render() {
        return (
            <YBRecomendadorTalla
              { ...this.containerFunctions }
              { ...this.containerProps() }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(YBRecomendadorTallaContainer);
